import { ApiResponseObject } from "../../types";
import { axios } from "../../utils/axios";
import {
  ApiSettings,
  CompanyDetails,
  ICompanyObject,
  ICompanyObjectListResponse,
  IGetUsersResponse,
  IUserDetails,
  IUserDetailsResponse,
} from "./settings.types";

// Todo sync types with be when models are ready

const getCompanyDetails = (): Promise<ApiResponseObject<CompanyDetails>> => {
  return axios.get("detaljiDrustva");
};

const getCompanyUsers = (): Promise<ApiResponseObject<IGetUsersResponse>> => {
  return axios.get("sviKorisniciDrustva");
};

const getUsersDetails = (
  userId: string
): Promise<ApiResponseObject<IUserDetailsResponse>> => {
  return axios.get(`detaljiKorisnikaDrustva?id=${userId}`);
};

const addCompanyUser = (
  payload: IUserDetails
): Promise<ApiResponseObject<IUserDetails>> => {
  return axios.post("dodajKorisnikaDrustva", payload);
};

const editCompanyUser = (
  payload: IUserDetails
): Promise<ApiResponseObject<any>> => {
  return axios.put("izmeniKorisnikaDrustva", payload, {
    params: { id: payload.id },
  });
};

const getCompanyObjects = (
  aktivno?: boolean
): Promise<ApiResponseObject<ICompanyObjectListResponse>> => {
  return axios.post("drustvoObjekti", { aktivno });
};

const getObjectDetails = (
  objectId: number
): Promise<ApiResponseObject<ICompanyObject>> => {
  return axios.get(`detaljiDrustvoObjekat`, {
    params: { drustvoObjekatId: objectId },
  });
};

const addCompanyObject = (
  payload: ICompanyObject
): Promise<ApiResponseObject<any>> => {
  return axios.post("dodajObjekat", payload);
};

const editCompanyObject = (
  payload: ICompanyObject
): Promise<ApiResponseObject<any>> => {
  return axios.put("izmeniObjekat", payload, { params: { id: payload.id } });
};

const getApiSettings = (): Promise<ApiResponseObject<ApiSettings>> => {
  return axios.get("konfiguracijaDrustvo");
};

const refreshApiKey = (): Promise<ApiResponseObject<string>> => {
  return axios.get("obnoviKljucDrustvo");
};

const editNotificationEmail = (
  email: string | undefined
): Promise<ApiResponseObject<string>> => {
  return axios.get("promeniEmailKonfiguracije", { params: { email } });
};
const editNotificationStatus = (
  status: boolean
): Promise<ApiResponseObject<boolean>> => {
  return axios.get("promeniStatusKonfiguracije", { params: { status } });
};

const getPromeniStatusEmailNotifikacija = (
  status: boolean
): Promise<ApiResponseObject<boolean>> => {
  return axios.get("iskljuciEmailNotifikacije", { params: { status } });
};

export const settingsRepo = {
  getCompanyDetails,
  getCompanyUsers,
  getUsersDetails,
  addCompanyUser,
  editCompanyUser,
  getCompanyObjects,
  getObjectDetails,
  addCompanyObject,
  editCompanyObject,
  getApiSettings,
  refreshApiKey,
  editNotificationEmail,
  editNotificationActive: editNotificationStatus,
  getPromeniStatusEmailNotifikacija,
};
